import { render, staticRenderFns } from "./SmsStats.vue?vue&type=template&id=6a83b6ae&scoped=true&"
import script from "./SmsStats.vue?vue&type=script&lang=js&"
export * from "./SmsStats.vue?vue&type=script&lang=js&"
import style0 from "./SmsStats.vue?vue&type=style&index=0&lang=css&"
import style1 from "./SmsStats.vue?vue&type=style&index=1&id=6a83b6ae&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a83b6ae",
  null
  
)

export default component.exports